import {
  BulkMoveJobCatalogTreeNodeDocument,
  BulkMoveJobCatalogTreeNodeMutation,
  JobCatalogTreePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface BulkMoveJobCatalogTreeNodeParams {
  companyId: number
  newParentUuid: string
  nodeUuids: string[]
}

export const useBulkMoveJobCatalogTreeNode = () => {
  const [bulkMoveJobCatalogTreeNode, { loading }] = useMutation(
    BulkMoveJobCatalogTreeNodeDocument,
    {
      extractorFn: (data: BulkMoveJobCatalogTreeNodeMutation) =>
        data.jobCatalogMutations.bulkMoveJobcatalogTreeNode,
      refetchQueries: [JobCatalogTreePageDocument],
      awaitRefetchQueries: true,
    }
  )

  const bulkMoveJobCatalogTreeNodes = async ({
    companyId,
    newParentUuid,
    nodeUuids,
  }: BulkMoveJobCatalogTreeNodeParams) => {
    return bulkMoveJobCatalogTreeNode({
      variables: {
        companyId,
        newParentUuid,
        nodeUuids,
      },
    })
  }

  return {
    bulkMoveJobCatalogTreeNodes,
    loading,
  }
}
